module.exports = __webpack_public_path__ + "img/cu09.ea2eb581.jpg";